// Generated by ReScript, PLEASE EDIT WITH CARE


var t = [
  {
    title: "Journey 1",
    id: "7"
  },
  {
    title: "Journey 2",
    id: "8"
  },
  {
    title: "Journey 3",
    id: "9"
  },
  {
    title: "Journey 4",
    id: "10"
  }
];

function journeyToColor(id) {
  switch (id) {
    case "10" :
        return "#bb8835";
    case "7" :
        return "#9e62a1";
    case "8" :
        return "#435eb8";
    case "9" :
        return "#1d7d50";
    default:
      throw {
            RE_EXN_ID: "Match_failure",
            _1: [
              "WordFlyersJourneys.res",
              16,
              2
            ],
            Error: new Error()
          };
  }
}

export {
  t ,
  journeyToColor ,
}
/* No side effect */
